const endpoints = {
	chatWithTools: '/bot/chatWithTools',
}
export {endpoints}